import {assertEqual} from "../../unittests/UnitTestHelper";
import {getProductParamsTest} from "../../logic/setup/ProdcutParamsParser";
import {parseUrl} from "../../logic/setup/ParametersParser";
import {appdata} from "../../logic_tmp/appdata/AppData";

export function testLeadPageLogic() {

    assertEqual("PleaseEnterEMail", validateEmailImpl(""))
    assertEqual("PleaseEnterEMail", validateEmailImpl(" "))
    assertEqual("PleaseEnterCorrectEMail", validateEmailImpl("sdasdas"))
    assertEqual("OK", validateEmailImpl("aleksei.bljahhin@gmail.com"))
    assertEqual("OK", validateEmailImpl("", true))
    assertEqual("OK", validatePhoneImpl("+3725142537"))
    assertEqual("OK", validatePhoneImpl("3725142537"))
    assertEqual("OK", validatePhoneImpl("5142537"))
    assertEqual("5DigitsMin", validatePhoneImpl("5142a537"))
    assertEqual("PleaseEnterPhone", validatePhoneImpl(""))
    assertEqual("12345", cleanPhoneString("1-2-3 4_5"))
    let data = parseUrl({}, getProductParamsTest())
    validateDataBeforeSendingTobackend(data)
    data.spKeyRedim = undefined
    data.amount = 10
    assertEqual("/payment", leadPageCalculateNextStep(data))
    data.amount = 0
    assertEqual("/ok", leadPageCalculateNextStep(data))
}


export function leadPageCalculateNextStep(data) {
    if (data.leadSubAction === "SpecialProposal")
    {
        data.messageKey = "ThankYouGoToEmailForInstruction"
        return "/genericMessage"
    }
    if ("LEADGEN" === data.action || "LEADGEN" === data.product.type)
    {
        return "/leadok"
    }
    if (data.product.eventStatus === "SOLD" && !data.admin)
    {
        data.messageKey = "AllTicketsSold"
        return "/genericMessage"
    }
    if ((data.product.priceModel === "FLEX" && data.amount === 0)    || data.product.priceModel === "FREE")
        return "/ok"
    return "/payment"
}

export function validateEmailImpl(emailstr, optional) {
    emailstr = emailstr.trim()
    if (!emailstr)
        if (optional)
            return "OK"
        else
            return "PleaseEnterEMail"
    if (typeof emailstr !== "undefined") {
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (!pattern.test(emailstr)) {
            return "PleaseEnterCorrectEMail"
        }
    }
    return "OK"
}

export function validatePhoneImpl(phoneStr, optional) {
    if (!phoneStr || !(phoneStr.trim()))
        if (optional)
            return "OK"
        else
            return "PleaseEnterPhone"
    let pattern = new RegExp(/^(\+)?\d{5,}$/);
    if (!pattern.test(phoneStr)) {
        return "5DigitsMin"
    }
    return "OK"
}

export function cleanPhoneString(phoneString) {
    const separatorsRegex = new RegExp(/[-,|_]/g)
    return phoneString.replace(separatorsRegex, '').replace(" ", "")
}

export function validateDataBeforeSendingTobackend(data) {
    if (data.language === undefined || data.language.trim().length < 2)
        throw Error("Missed language")
    if (data.count === 0)
        throw Error("Missed count!")
}




